<template>
  <div class="root-porpos">
    <div>
      <h4 class="icon-title"><span class="paragraph-icon"></span>合同起草</h4>
      <el-form :model="form" :rules="rules" label-position="top" ref="darfForm">
        <el-form-item label="合同名称:" prop="docName">
          <el-input
            v-model="form.docName"
            placeholder="请输入合同名称"
            style="width: 450px"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同文件:" prop="docFile">
          <div class="file-list">
            <draggable
              class="file-draggable"
              element="ul"
              :list="fileList"
              @start="dragging = true"
              @end="dragging = false"
              :options="{
                handle: '.icon-move_box',
                animation: 200,
                ghostClass: 'ghost',
              }"
              filter=".upload-btn"
            >
              <template v-for="(file, index) of fileList">
                <transition-group type="transition" :key="index">
                  <li class="upload-file" :key="index">
                    <div class="bx">
                      <img :src="fileSuffix(file.fileName)" />
                      <!--蒙层-->
                      <div class="msk">
                        <div class="msk-icon">
                          <i class="el-icon-view" @click="previewDoc(file)"></i>
                          <i
                            class="el-icon-delete-solid"
                            @click="removeFile(index, file)"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <p class="title" :title="file.fileName">
                      {{ file.fileName }}
                    </p>
                    <div class="icon-move_box"><i></i></div>
                  </li>
                </transition-group>
              </template>
              <div class="upload-btn" v-show="fileList.length === 0">
                <el-upload
                  action="#"
                  :limit="1"
                  :show-file-list="false"
                  :on-exceed="exceed"
                  accept=".doc,.docx"
                  :before-upload="fileUpload"
                  :file-list="fileList"
                >
                  <slot>
                    <div class="upload-content">
                      <span class="el-icon-plus"></span>
                      <p class="tip">上传 doc、docx 格式文件,<br/>且不超过 30M!</p>
                    </div>
                  </slot>
                </el-upload>
              </div>
            </draggable>
          </div>
        </el-form-item>
        <el-form-item label="拟定人员" required>
          <div class="propos-box">
            <el-form
              v-for="(item, i) in propos"
              :key="i"
              :model="item"
              inline
              ref="drafUseForm"
              style="margin-bottom: 2vh;"
            >
              <el-form-item
                :label="`合同拟定方${i + 1}: `"
                prop="phoneOrEmail"
                :rules="propRule"
              >
                <el-input
                  clearable
                  v-model="item.phoneOrEmail"
                  placeholder="请输入邮箱/手机号"
                  style="padding-left: 15px"
                  @input="partAdd(i, $event)"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="名称: "
                prop="userName"
                :rules="[
                  { required: true, message: '请输入名称', trigger: 'blur' },
                ]"
              >
                <el-input
                  v-model="item.userName"
                  placeholder="请输入名称"
                  style="padding-left: 15px"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div class="propos-action">
                  <img
                    src="/images/AISmart/icon/del.png"
                    alt=""
                    style="margin-right: 20px"
                    v-show="propos.length - 1 > 0"
                    @click="delItem(item)"
                  />
                  <img
                    src="/images/AISmart/icon/puls.png"
                    alt=""
                    v-show="propos.length - 1 == i"
                    @click="addItem"
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
        </el-form-item>
        <!-- 拟定人员 end -->
        <el-form-item class="submit-btn">
          <!-- $router.push({ path: '/smartDoc/docDraft/draft' }) -->
          <el-button plain @click="$router.go(-1)">返回</el-button>
          <el-button type="primary" @click="drafStart">立即发起协作</el-button>
        </el-form-item>
      </el-form>
      <!--pdf文件预览-->
      <view-files-to-doc
        :visibleShow="visibleShowEnclosureDoc"
        :enclosurePreviewNumItem="enclosurePreviewNumItem"
        @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
      />
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
// 接口
import {
  ApiMethods,
  postFindByEmailOrMphon,
  postFileTempUpload
} from "@/assets/js/http-serve/http-methods";
import {
  mobileOrEmail,
  happy
} from "@/assets/js/lib/valid-methods";
import { isInDingTalk } from '../../assets/js/utils/ding-env';
export default {
  data () {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      fileList: [],
      dragging: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      // pdf 预览
      visibleShowEnclosureDoc: false,
      loading: null,
      form: {
        docName: "",
        docFile: []
      },
      rules: {
        docName: [
          {
            required: true,
            message: "请输入合同名称",
            trigger: "blur"
          }
        ],
        docFile: [
          {
            required: true,
            message: "请上传合同文件",
            trigger: "blur"
          }
        ]
      },
      propos: [
        {
          phoneOrEmail: "",
          userName: ""
        }
      ],
      propRule:[
        {
          required: true,
          message: '请输入邮箱/手机号',
          trigger: ['blur', 'change'],
        },
        { validator: mobileOrEmail, trigger: ['blur', 'change'] }
      ]
    };
  },
  // data end
  methods: {
    // 发起协作
    drafStart () {
      let _that = this;
      // validate
      if (this.fileList.length !== 1)
        return this.$message.error("请上传要发起的合同文件");
      _that.$refs.darfForm.validate(vaild => {
        if (vaild) {
          let phoneList = [];
          for (let i = 0; i < _that.propos.length; i++) {
            const prop = _that.propos[i];
            if (!prop.phoneOrEmail)
              return this.$message.error("请完成相关拟定方设置");
            phoneList.push(prop.phoneOrEmail);
          }
          this.loadingStart("正在发起中~");
          const { docName, docFile } = this.form;
          const param = {
            fileName: docName,
            fileType: docFile[0].fileType,
            tempStoreId: docFile[0].targetId,
            emailOrMobileList: phoneList
          };
          this.smartAPI
            .draftUseFile(param)
            .then(res => {
              if (res.success) {
                this.$router.push({ path: "/smartDoc/docDraft/draftList" });
              } else {
                if (res.code == 10807) {
                  this.buyDia();
                  return;
                }
                this.$message.error(res.description);
              }
            })
            .finally(() => {
              this.loadingClose();
            });
        } // vaild end
      });
    },
    // 显示购买弹窗
    buyDia () {
      this.$confirm("当前无合同起草功能使用次数，请前往购买！", "提示", {
        type: "error"
      })
        .then(res => {
          const url = this.globalConfig.domain.accountWeb + "/asset/aiContractChargePage"
          isInDingTalk ? location.href = url : window.open(url);
        })
        .catch(err => {
          // this.$message.error("err", err);
        });
    },
    // 查询拟定方是否存在及公司信息
    partAdd (index, val) {
      const phoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
        EmailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (phoneReg.test(val) || EmailReg.test(val)) {
        postFindByEmailOrMphon({targetId:val}).then(res => {
          if (res.success) {
            this.propos[index].userName = res.data[0].name;
          } else {
            this.$message.error(res.description);
          }
        });
      }
    },
    // 添加拟定方
    addItem () {
      this.propos.push({
        phoneOrEmail: "",
        userName: ""
      });
    },
    // 删除拟定方
    delItem (item) {
      var index = this.propos.indexOf(item);
      if (index !== -1) {
        this.propos.splice(index, 1);
      }
    },
    exceed (files, fileList) {
      // this.$message.warning("仅支持单文件上传,请删除后重新上传");
    },
    // 文件上传
    fileUpload (file, fileList) {
      console.log("file", file);
      this.fileList = [];
      const re = new RegExp("(.doc|.docx)$", "i");
      const isLt30M = file.size / 1024 / 1024 < 30;
      if (!re.test(file.name)) {
        return this.$message.error("文件格式只能是 doc/docx 文件");
      }
      if (!isLt30M) {
        return this.$message.error("上传文件大小不能超过 30MB!");
      }
      this.loadingStart("文件上传中~");
      postFileTempUpload({ file, fileType: 1 })
        .then(data => {
          this.coverInfod({ name: data.file.name, ...data.tempFile });
          return;
        })
        .catch(err => {
          this.loadingClose();
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    // 获取文件后缀
    fileSuffix (fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      // return filesuffix;
      switch (filesuffix) {
        case "pdf":
          return "/images/advancedVersion/pdf.png";
        case "doc":
        case "docx":
          return "/images/advancedVersion/word.png";
        default:
          return "/images/advancedVersion/WPS.png";
      }
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 预览文档
    previewDoc (item) {
      console.log("perviewItem", item);
      const { fileOperVO: VO } = item;
      let files = {
        id: VO.targetId,
        file: {
          fileType: VO.fileType,
          sign: VO.sign,
          targetId: VO.targetId,
          ts: VO.ts,
          fileName: item.fileName
        }
      };
      this.enclosurePreviewNumItem = files;
      this.visibleShowEnclosureDoc = true;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 删除已上传的文件
    removeFile (index, file) {
      this.fileList.splice(index, 1);
    },
    // 转PDF
    coverInfod (info) {
      this.loadingStart();
      const { name, targetId, fileType, sign, ts } = info;
      // 非用户自己点击的文件上传，需要先用路由中带来的文件信息请求PDF文件(用于预览)
      this.smartAPI.converToPDF({ ...info }).then(res => {
        this.form.docFile[0] = info;
        let file_name = `${name}.${targetId.substring(
          targetId.lastIndexOf(".") + 1,
          targetId.length
        )}`,
          { data } = res;
        this.fileList.push({
          fileName: file_name,
          targetId,
          fileType,
          tempFile: data.tempFile,
          items: data.items,
          sort: null,
          fileOperVO: {
            docHash: data.docHash,
            // extendsLocation: "",
            fileName: file_name,
            // fileSize: data.file.size,
            fileType: data.tempFile.fileType,
            sign: data.tempFile.sign,
            targetId: data.tempFile.targetId,
            // targetIdForPreview: "",
            ts: data.tempFile.ts
          }
        });
        this.loadingClose();
      });
    },
    converFile (info) {
      const param = { fileName: info.name, tplId: info.tplCode };
      this.loadingStart();
      this.smartAPI.converDown(param).then(res => {
        if (res.success) {
          this.coverInfod({ name: info.name, ...res.data });
        } else {
          this.$message.error(res.description);
        }
      });
    }
  },
  components: { draggable, ViewFilesToDoc },
  created () {
    const { name, contractDraftId, tplCode } = this.$route.params;
    if (name) this.form.docName = name;
    if (tplCode) {
      // 协同起草（先获取模板文件）
      this.converFile({ name, tplCode });
    }
    if (contractDraftId) {
      // 再次起草（先获取合同文件）
      this.loadingStart();
      this.smartAPI.draftApplySign({ draftId: contractDraftId }).then(res => {
        if (res.success) {
          this.coverInfod({ name, ...res.data });
        } else {
          this.$message.error(res.description);
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.root-porpos {
  background-color: #fff;
  padding: 15px;
  .paragraph-icon {
    display: inline-block;
    width: 5px;
    height: 15px;
    background: rgba(38, 38, 38, 1);
    border-radius: 100px;
    margin-right: 10px;
  }
  .icon-title {
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  .propos-box {
    width: 100%;
    height: 35vh;
    overflow: auto;
    .propos-action {
      > img {
        width: 34px;
        height: 34px;
        cursor: pointer;
      }
    }
  }
  .submit-btn {
    display: flex;
    justify-content: center;
  }
  .upload-file {
    width: 175px;
    height: 140px;
    border: 1px solid #dcdcdc;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    color: rgba(41, 2, 2, 0.45);
    position: relative;
    cursor: pointer;
    margin: 20px;

    &:hover {
      .icon-move_box {
        display: block;
      }

      .msk {
        width: 100%;
        height: 105px;
        display: block;
      }
    }

    .msk {
      overflow: hidden;
      position: absolute;
      width: 0;
      height: 0;
      left: 0;
      top: 0;
      bottom: 35px;
      right: 0;
      display: none;
      z-index: 3;
      transition: all ease-in 0.2s;
      background: rgba(0, 0, 0, 0.5);

      .msk-icon {
        position: absolute;
        width: 100%;
        font-size: 20px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;
        padding: 0 20px;
        color: #fff;
        cursor: pointer;
      }
    }

    .bx {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 35px;
      z-index: 1;

      img {
        height: 48px;
        width: auto;
        margin-top: 28px;
      }
    }

    .title {
      z-index: 1;
      position: absolute;
      left: 0;
      bottom: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: 0 10px;
      background: #efefef;
      text-align: center;
      height: 35px;
      width: 100%;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #290202;
      line-height: 35px;
    }

    .icon-move_box {
      position: absolute;
      left: 50%;
      width: 20px;
      height: 20px;
      bottom: -10px;
      transform: translateX(-50%);
      z-index: 5;
      display: none;
    }

    .icon-move_box i {
      background: url("../../assets/images/move-icon-default.png") no-repeat
        center center;
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
      display: block;
      color: #ec1c1c;
      text-align: center;
      font-size: 20px;
    }

    .icon-move_box i:hover {
      cursor: move;
      background: url("../../assets/images/move-icon.png") no-repeat center
        center;
      background-size: 100% 100%;
    }
  }
  .upload-btn {
    width: 175px;
    height: 140px;
    border: 1px solid #dcdcdc;
    opacity: 1;
    border-radius: 4px;
    color: rgba(41, 2, 2, 0.45);
    position: relative;
    overflow: hidden;
    cursor: pointer;
    margin: 20px;

    .upload-content {
      width: 175px;
      height: 140px;
      text-align: center;
    }

    .el-icon-plus {
      font-size: 40px;
      font-weight: bold;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .tip {
      font-size: 12px;
      position: absolute;
      left: 0;
      bottom: 0;
      background: #efefef;
      text-align: center;
      height: 40px;
      width: 100%;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #888888;
      line-height: 1;
    }
  }
  .file-list {
    height: auto;
    width: 100%;
  }
  .file-draggable {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// pages/smartContract/proposed.vue